export default function StatsSection() {
  const stats = [
    { number: '10,000', unit: '本以上', label: '制作本数' },
    { number: '500', unit: '店舗以上', label: '導入店舗' },
    { number: '92', unit: '%', label: '顧客満足度' },
    { number: '80', unit: '%', label: 'リピート率' },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-purple-950/20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`text-center py-8 px-4 ${
                index < stats.length - 1 ? 'md:border-r border-white/10' : ''
              } ${index % 2 === 0 ? 'border-r border-white/10 md:border-r-0' : ''} ${
                index < 2 ? 'border-b border-white/10 md:border-b-0' : ''
              }`}
            >
              <div className="text-sm md:text-base text-gray-400 font-light tracking-wider mb-3">
                {stat.label}
              </div>
              <div className="flex items-end justify-center gap-1">
                <span className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200 leading-tight whitespace-nowrap">
                  {stat.number}
                </span>
                <span className="text-sm md:text-base font-medium text-yellow-300/80 mb-1 whitespace-nowrap">
                  {stat.unit}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
